/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { WithLazy } from "@quintype/components";
import PropTypes from "prop-types";
import React, { useState } from "react";

/*
 * This component is used in the case where we want WithLazy to trigger
 * a passed function instead of rendering something directly. Use this
 * component only when your focus is on running a function instead of
 * displaying a component directly via IntersectionObserver.
 *
 * Implementation follows Google Publisher Tag lazy loading guidelines:
 * https://developers.google.com/publisher-tag/samples/lazy-loading?hl=en
 */
const WithLazyTrigger = props => {
  const [onIntersectionCalled, setOnIntersectionCalled] = useState(false);
  return (
    // Margin set to 200px to trigger intersection 200px before the element enters viewport
    // This allows for earlier loading and better user experience
    <WithLazy margin="200px">
      {() => {
        // To prevent any potential re-rendering
        if (!onIntersectionCalled) {
          props.onIntersection();
          setOnIntersectionCalled(true);
        }
        return <></>;
      }}
    </WithLazy>
  );
};

WithLazyTrigger.propTypes = {
  onIntersection: PropTypes.func
};

export default WithLazyTrigger;
